<div class="content-card filters">
  <div class="top">
    <div class="top__left">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="space-around center">
          <button mat-icon-button (click)="previousDay()">
            <mat-icon>keyboard_arrow_left</mat-icon>
          </button>
          <span class="date-label" (click)="picker.open()">
            {{ currentDate | date : 'dd.MM.yyyy' }}
          </span>
          <button mat-icon-button (click)="nextDay()">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </button>
          <div class="datepicker">
            <input matInput [matDatepicker]="picker" (dateChange)="onDateChange($event)" readonly />
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <button mat-icon-button (click)="picker.open()">
            <mat-icon>event</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="top__right">
      @if (showFilterPresetSelector) {
        <mat-form-field [@inOutAnimation] appearance="outline" class="filter-preset-selector">
          <mat-label>Filtr</mat-label>
          <mat-select [value]="selectedFilterPresetId" (valueChange)="setSelectedFilterPresetId($event)">
            @for (preset of filterPresets; track preset) {
              <mat-option [value]="preset.Id">{{
                preset.Name === defaultFilterPresetName ? ('DefaultFilterPresetName' | translate) : preset.Name
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <button (click)="resetFilters()" class="top__button top__button-clear">
        <mat-icon>close</mat-icon>
        {{ 'Reset' | translate }}
      </button>
      <button (click)="toggleFiltersPanel()" class="top__button top__button-filter">
        <mat-icon>filter_alt</mat-icon>
        {{ 'Filter' | translate }}
      </button>
    </div>
  </div>
  @if (areFiltersExpanded) {
    <div #filterSection>
      @if (areFiltersExpanded) {
        <app-presence-per-day-list-filters [formGroup]="filtersFormGroup" (filterGridData)="filterData($event)">
          <div class="favorite-button-row-container">
            <button (click)="saveFilterPresetButtonClick()" class="favorite-button">
              @if (isSavedFilterPreset) {
                <mat-icon>bookmark</mat-icon>
                {{ 'UnsaveFilter' | translate }}
              } @else {
                <mat-icon>bookmark_border</mat-icon>
                {{ 'SaveFilter' | translate }}
              }
            </button>
          </div>
        </app-presence-per-day-list-filters>
      }
    </div>
  }
</div>

<div class="content-card">
  <div class="table-wrapper custom-table" [style.max-height]="listHeight">
    <mat-table #table matSort matSortActive="company" matSortDirection="desc" matSortDisableClear [dataSource]="dataSource.presences$ | async">
      <ng-container matColumnDef="workerFullName" [sticky]="screenService.isAboveMd$ | async">
        <mat-header-cell *matHeaderCellDef mat-sort-header="LastName" class="hidden-sort">
          {{ 'PresencePerDayList.WorkerFullName' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element"
          ><a [routerLink]="['/profile', element.WorkerId, 'timesheets']">{{ element.LastName }} {{ element.FirstName }}</a></mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="pesel">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'Pesel' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.Pesel }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="company">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'Company' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" [matTooltip]="element.Company" [matTooltipPosition]="'above'">{{ element.Company }}</mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="employerObject">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'EmployerObject' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" [matTooltip]="element.EmployerObject" [matTooltipPosition]="'above'">{{
            element.EmployerObject
          }}</mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="employmentType">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'EmploymentType' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.EmploymentType }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="startDate">
          <mat-header-cell *matHeaderCellDef class="hidden-sort">
            {{ 'PresencePerDayList.StartTime' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            @for (item of element.Periods; track item) {
              <span class="period-wrapper">
                <span class="work-mode-wrapper">{{ item.StartDate | date : 'HH:mm' }}</span>
                @for (workMode of item.WorkModes; track workMode; let first = $first) {
                  <span>
                    @if (!first) {
                      <span class="work-mode-wrapper"></span>
                    }
                  </span>
                }
              </span>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="endDate">
          <mat-header-cell *matHeaderCellDef class="hidden-sort">
            {{ 'PresencePerDayList.EndTime' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            @for (item of element.Periods; track item) {
              <span class="period-wrapper">
                <span class="work-mode-wrapper">{{ item.EndDate | date : 'HH:mm' }}</span>
                @for (workMode of item.WorkModes; track workMode; let first = $first) {
                  <span>
                    @if (!first) {
                      <span class="work-mode-wrapper"></span>
                    }
                  </span>
                }
              </span>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="totalTimespan">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'PresencePerDayList.TotalTimespan' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.TotalTimespan ? (element.TotalTimespan | ticksToString) : '' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="workModes">
          <mat-header-cell *matHeaderCellDef class="hidden-sort">
            {{ 'PresencePerDayList.WorkMode' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            @for (item of element.Periods; track item) {
              <span class="period-wrapper">
                @for (workMode of item.WorkModes; track workMode) {
                  <span class="work-mode-wrapper">
                    {{ workMode.NameLang }}
                  </span>
                }
                @if (!item.WorkModes.length) {
                  <span class="work-mode-wrapper"></span>
                }
              </span>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="absenceType">
          <mat-header-cell *matHeaderCellDef class="hidden-sort">
            {{ 'PresencePerDayList.Absence' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            @for (item of element.AbsenceTypes; track item) {
              <span>{{ item }}</span>
            }
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>
    <mat-paginator [length]="dataSource.count$ | async" [pageSize]="25" [pageSizeOptions]="[25, 50, 100]"> </mat-paginator>
  </div>
